import axiosClient from '@/api/axiosClient';
import { API_GET_PIECE, API_UPDATE_PIECE, API_DELETE_PIECE } from '@/config/paths/API_PATH';

async function getPieceList({ prizeId }) {
  const { data } = await axiosClient.get(API_GET_PIECE, {
    params: {
      prize_id: prizeId,
    },
  });

  return data;
}

async function updatePieceList(formData) {
  const { data } = await axiosClient.post(API_UPDATE_PIECE, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}

async function deletePieceList(dataParams) {
  const { data } = await axiosClient.post(API_DELETE_PIECE, dataParams);

  return data;
}

export { getPieceList, updatePieceList, deletePieceList };
